import React from 'react';
import {HorizontalBar} from 'react-chartjs-2';

export default class SingleBarChart extends React.Component {
	constructor(props) {
		super(props);

	}


	render () {
	
	var data = {
        					    //labels: [0,1,2,3,4,5,6,7,8,9,10,11],
        					    labels: ["kgCO2 pro Monat"],
        					    datasets: [
        					        {
        					            label: "CO2",
        					            backgroundColor: this.props.color,
        					            borderColor: "rgba(173, 106, 13,0.8)",
        					            highlightFill: "rgba(220,220,220,0.75)",
        					            highlightStroke: "rgba(220,220,220,1)",
        					            data: [Math.round((this.props.co2 / 1000) * 100) / 100]
        					        }
        					    ]
        					}

      var options = {
		
		scales: {
            xAxes: [{
		stacked: true,
		ticks: {
                    min: 0,
                    max: 500,
		    stepSize: 100
                }
                }
            ]
        },
	
	legend: {
            display: false
         }
		
			
		}


	return (
<HorizontalBar data={data} options={options} height={60} />
	)
	}
}





// WEBPACK FOOTER //
// ./src/react_components/livingplaceprocess/dailytrips/co2_chart.js